webpackJsonp([39926295202337],{

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Address = function Address(_ref) {
	  var address = _ref.address;
	
	  return _react2.default.createElement(
	    'address',
	    null,
	    address.map(function (part, index) {
	      return _react2.default.createElement(
	        'p',
	        { key: 'part-' + index },
	        part
	      );
	    })
	  );
	};
	
	Address.propTypes = {
	  address: _propTypes2.default.array.isRequired
	};
	
	exports.default = Address;
	module.exports = exports['default'];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Lead = __webpack_require__(43);
	
	var _Lead2 = _interopRequireDefault(_Lead);
	
	var _Address = __webpack_require__(42);
	
	var _Address2 = _interopRequireDefault(_Address);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Privacy = function Privacy(_ref) {
	  var data = _ref.data;
	  var contactDetails = data.site.siteMetadata.contactDetails;
	  var address = contactDetails.address,
	      telephoneNumber = contactDetails.telephoneNumber,
	      emailAddress = contactDetails.emailAddress;
	
	
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Privacy Notice'
	    ),
	    _react2.default.createElement(
	      _Lead2.default,
	      null,
	      '(Why I collect your personal data and what we do with it)'
	    ),
	    _react2.default.createElement(
	      _Lead2.default,
	      null,
	      'When you supply your personal details to this clinic they are stored and processed for 4 reasons (the bits in bold are the relevant terms used in the General Data Protection Regulation \u2013 ie the law):'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'I need to collect personal information about your health in order to provide you with the best possible treatment. Your requesting treatment and my agreement to provide that care constitutes a ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'contract'
	          ),
	          '. You can, of course, refuse to provide the information, but if you were to do that I would not be able to provide treatment.'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'I have a ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            '"Legitimate Interest"'
	          ),
	          ' in collecting that information, because without it I couldn\u2019t do my job effectively and safely.'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'I also think that it is important that I can contact you in order to confirm your appointments with me or to update you on matters related to your medical care. This again constitutes ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            '"Legitimate Interest"'
	          ),
	          ', but this time it is your legitimate interest.'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Provided I have your ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'consent'
	          ),
	          ', I may occasionally send you general health information in the form of articles, advice or newsletters. You may withdraw this consent at any time \u2013 just let me know by any convenient method.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I have a ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'legal obligation'
	      ),
	      ' to retain your records for 8 years after your most recent appointment (or age 25, if this is longer), but after this period you can ask me to delete your records if you wish. Otherwise, I will retain your records indefinitely in order that I can provide you with the best possible care should you need to see me at some future date.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Your medical records and contact details are stored on paper, in a locked clinic out of working hours.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Your contact number and email are also stored on my finger print protected phone and password protected computer.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I will never share your data with anyone who does not need access without your written consent. Only the following people/agencies will have routine access to your data: \u2028'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Myself in order that I can provide you with treatment.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'From time to time, I may have to employ consultants to perform tasks which might give them access to your personal data (but not your medical notes). I will ensure that they are fully aware that they must treat that information as confidential, and I will ensure that they sign a non-disclosure agreement.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You have the right to see what personal data of yours I hold, and you can also ask me to correct any factual errors. Provided the legal minimum period has elapsed , you can also ask me to erase your records.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I want you to be absolutely confident that we are treating your personal data responsibly, and that we are doing everything we can to make sure that the only people who can access that data have a genuine need to do so.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Of course, if you feel that I am mishandling your personal data in some way, you have the right to complain. Complaints need to be sent to what is referred to in the jargon as the \u201CData Controller\u201D. Here are the details you need for that:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Ian Willmott'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'mailTo:' + emailAddress },
	          emailAddress
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'tel:' + telephoneNumber },
	          telephoneNumber
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(_Address2.default, { address: address })
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you are not satisfied with my response, then you have the right to raise the matter with the Information Commissioner\u2019s Office.'
	    )
	  );
	};
	
	exports.default = Privacy;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-privacy-notice-js-c4f7c9caec3cd85c793a.js